import { render } from "./SuccessSnackbar.vue?vue&type=template&id=fee2e10c"
import script from "./SuccessSnackbar.vue?vue&type=script&lang=js"
export * from "./SuccessSnackbar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__